module.exports = __webpack_public_path__ + "static/img/1_03.ea96086.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/1_03.png
// module id = rRUm
// module chunks = 6